import { useEffect } from "react";
import type { ChipProps } from "@mui/material";
import { Tag } from "src/components/general/Tag/Tag";
import { useToggleTagSelection } from "./ToggleableAppTag.hooks";

type ToggleableAppTagProps = {
  tag: string;
  tagId: number;
} & Omit<ChipProps, "label" | "variant">;

/**
 * Business Tag that toggles `appTags` in search storage on click.
 * Click order: toggle first, then caller `onClick`. Caller handlers that read
 * `appTags` from the render closure see the pre-toggle value (setState is async).
 */
const ToggleableAppTag = ({
  tag,
  tagId,
  onClick,
  ...props
}: ToggleableAppTagProps) => {
  const toggleTag = useToggleTagSelection();

  useEffect(() => {
    if (tagId == null) {
      console.error("ToggleableAppTag was called without required tagId");
    }
  }, [tagId]);

  return (
    <Tag
      tag={tag}
      {...props}
      onClick={(e) => {
        // Toggle before caller onClick — do not read fresh appTags in this tick
        // (ExecutionHealth relies on pre-toggle closure for group-by side effects).
        toggleTag(tagId);
        onClick?.(e);
      }}
    />
  );
};

export default ToggleableAppTag;
